import React from 'react';
import {Grid, Segment} from 'semantic-ui-react';
import {filter, toLower, get, size} from 'lodash';
import useCheckboxHandle from './useCheckboxHandle';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Alert} from 'componentLibrary';
import ActionSubApplicationModal from './actionSubApplicationModal';
import {TextBlock} from 'app-ui-componentlibrary/dist/go/components/common/content/TextBlock';
import {convertValueToDollar} from 'common/utils';
import {getHeaders, getRows} from './subApplicationTableParts';

const SubApplicationTable = (props) => {
  const {
    columns,
    totalAmount,
    results,
    title,
    categoryLabel,
    categoryOptions,
    cbResults,
    handleValidateAndSaveRank,
    handleChange,
    errors,
    options,
    handleCardDelete,
    handleSave,
    readOnly,
  } = props;

  const [
    tableItems,
    masterChecked,
    handleCheckboxChange,
    handleMasterCheckbox,
  ] = useCheckboxHandle(cbResults);
  const headers = getHeaders(masterChecked, columns, {
    handleMasterCheckbox,
    readOnly,
  });
  const rows = getRows(columns, results, {
    handleCheckboxChange,
    handleValidateAndSaveRank,
    handleChange,
    errors,
    cbResults: tableItems,
    categoryOptions,
    handleCardDelete,
    handleSave,
    categoryLabel,
    readOnly,
    options: filter(options, ({categories}) => categories.includes('single')),
  });

  const fullname = `${title} ${categoryLabel}`;

  const categoryErrors = get(errors, title, []);
  return (
    <Segment>
      <Grid>
        <Grid.Row>
          <Grid.Column width={8} key={title + '-applications'}>
            <TextBlock title={`${title} ${toLower(categoryLabel)}`} isIndented />
          </Grid.Column>
          <Grid.Column width={8} key={title + '-fedShare'}>
            <TextBlock
              title={'Federal share total: ' + convertValueToDollar(totalAmount)}
              titleSize="h4"
              isIndented
              className="textRight"
            />
          </Grid.Column>
        </Grid.Row>
        {size(get(categoryErrors, 'errorMessage', '')) > 0 && (
          <Grid.Row>
            <Grid.Column width={16} key={title + '-applications-alert'}>
              <Alert
                size="tiny"
                header={get(categoryErrors, 'errorTitle')}
                type="error"
                dismissable={false}
              >
                {get(categoryErrors, 'errorMessage')}
                <b>{get(categoryErrors, 'errorExtras')}</b>
              </Alert>
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          {!readOnly && (
            <Grid.Column width={4} key={title + '-batchAction'}>
              <label htmlFor="batchAction" className="batch-action-header">
                Select an action
              </label>
              <ActionSubApplicationModal
                bulk
                {...{
                  masterChecked,
                  categoryLabel,
                  categoryOptions,
                  options: filter(options, ({categories}) => categories.includes('bulk')),
                  results: tableItems,
                  handleCardDelete,
                  handleSave,
                }}
              />
            </Grid.Column>
          )}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <FemaGoTable type="static" className="dropDownView" name={fullname}>
              <FemaGoTable.Header>
                <FemaGoTable.Row>{headers}</FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>{rows}</FemaGoTable.Body>
            </FemaGoTable>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default SubApplicationTable;
